import icons from './icons';
import replace from './replace';

export default { icons, replace };
